/**
 * スリープ
 */
export default {
  /**
   * スリープ（秒単位）
   *
   * @param sec 秒
   */
  sleep (sec) {
    return this.msleep(sec * 1000)
  },
  /**
   * スリープ（ミリ秒単位）
   *
   * @param msec 秒
   */
  msleep (msec) {
    return new Promise(resolve => setTimeout(resolve, msec))
  }
}
